'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _ResolutionText = require('./ResolutionText.css');

var _ResolutionText2 = _interopRequireDefault(_ResolutionText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampbellSoupResolutionText = (_dec = (0, _reactCssModules2.default)(_ResolutionText2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CampbellSoupResolutionText, _Component);

  function CampbellSoupResolutionText() {
    (0, _classCallCheck3.default)(this, CampbellSoupResolutionText);
    return (0, _possibleConstructorReturn3.default)(this, (CampbellSoupResolutionText.__proto__ || (0, _getPrototypeOf2.default)(CampbellSoupResolutionText)).apply(this, arguments));
  }

  (0, _createClass3.default)(CampbellSoupResolutionText, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _.Link,
            {
              to: 'https://www.asyousow.org/resolutions/2022/06/17-campbell-soup-report-on-aligning-retirement-plan-options-with-company-climate-goals',
              title: 'Campbell Soup shareholder resolution',
              xstrong: true
            },
            'More resolution details',
            _react2.default.createElement(_.LinkIcon, null)
          )
        ),
        _react2.default.createElement(
          'blockquote',
          { styleName: 'company-resolution-blockquote' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'WHEREAS:'
            ),
            ' Shareholders applaud Campbell Soup Company for adopting ambitious operational climate goals, including reducing absolute Scope 1 and 2 greenhouse gas emissions 42 percent by FY2030, and reducing deforestation impact by purchasing 100 percent Roundtable on Sustainable Palm Oil certified palm oil by the end of FY2021.[1]'
          ),
          _react2.default.createElement(
            'p',
            null,
            'While our company has made significant efforts to address climate change across its operations, data from Department of Labor filing,s including company retirement plan options and invested amounts, suggest to investors that Campbell\u2019s is failing to address the material risks of climate change in its 401(k) Plan in alignment with the duty to select retirement plan investment options in the best interests of plan participants and beneficiaries.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Campbell\u2019s 401(k) Plan uses Vanguard funds as its default retirement option, resulting in the vast majority of its $1.9 billion employee retirement dollars, as of December 31, 2020,[2] invested in funds holding companies that create substantial climate risk. A recent scorecard, produced by investor representative As You Sow, shows that the Campbell\u2019s 401(k) default option is rated Poor due to significant investments in fossil fuel companies and companies that cause deforestation risk.[3]'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Campbell\u2019s does not offer any sustainable investment options inside the Plan, nor does it offer employees a \u201Cself-directed\u201D investment option to choose other funds outside of the Plan.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In polls with investors broadly, more than 70 percent say that they would like to invest sustainably and, specifically, not in oil, coal, and deforestation. In the increasingly competitive employee retention and recruitment landscape, failing to provide climate-safe retirement plan options may also make it more difficult for Campbell\u2019s to attract and retain top talent.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Given the threat that climate change poses to workers\u2019 life savings, Campbell\u2019s should demonstrate that it is safeguarding employee financial security over time by mitigating climate change-related financial and economic risks as part of a prudently constructed lineup of funds.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Failing to satisfy this basic duty could be a liability for the Company, creating reputational risk and making it more difficult to retain employees increasingly concerned about catastrophic climate impacts.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'BE IT RESOLVED:'
            ),
            ' Shareholders request the board provide a report assessing how the Company\u2019s 401(k) retirement funds manage the growing systemic risk to the economy created by investing retirement Plan funds in companies contributing significantly to climate change.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'SUPPORTING STATEMENT:'
            ),
            ' Such analysis should include, at Board discretion, whether Plan decisionmakers have considered:'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              'Climate risk in Company 401(k) Plan offerings;'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Whether including high carbon companies in Company 401(k) Plan contributes to greater economic volatility over time, and the impact of such volatility on retirement fund performance over time;'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Whether including high carbon companies contributing to climate change puts younger Plan participants\u2019 retirement funds at greater economic risk than Plan participants nearer retirement age.'
            )
          )
        )
      );
    }
  }]);
  return CampbellSoupResolutionText;
}(_react.Component)) || _class);
exports.default = CampbellSoupResolutionText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ResolutionText/CampbellSoupResolutionText.js
// module id = 1432
// module chunks = 0